'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import usageTracker from '../../lib/usageTracker';
import { CTA_BOTTOM_BANNER_LINK } from '../../constants/TrialConstants';
import Logo from '../Logo';
import VideoModal from '../VideoModal';
import chatperson from 'bender-url!../../../img/chat-person.png';
import { parseUtmParams } from '../../util/Urls';

const TrialCtaPage = ({
  websiteUrl
}) => {
  const [showVideo, setShowVideo] = useState(false);
  const parsedUtmParams = parseUtmParams();

  const handleCtaClick = () => {
    const eventKey = 'academyCourseClick';
    const action = 'clicked-start-free-course-button';
    usageTracker.log(eventKey, {
      action,
      websiteUrl,
      source: 'results-footer'
    });
  };

  const onShowVideoModal = () => {
    if (!showVideo) {
      usageTracker.log('academyCourseClick', {
        action: 'clicked-watch-trailer-button',
        websiteUrl,
        source: 'results-footer'
      });
    }

    setShowVideo(!showVideo);
  };

  return /*#__PURE__*/_jsx("div", {
    className: "trial-cta-page",
    "data-reagan-selector": "trial-cta-page",
    children: /*#__PURE__*/_jsxs("div", {
      className: "wsg-container trial-cta-container",
      children: [showVideo && /*#__PURE__*/_jsx(VideoModal, {
        handleClose: onShowVideoModal,
        ctaLink: `${CTA_BOTTOM_BANNER_LINK}&${parsedUtmParams}`,
        websiteUrl: websiteUrl
      }), /*#__PURE__*/_jsxs("div", {
        className: "cta-container",
        children: [/*#__PURE__*/_jsx("div", {
          className: "cta-image-left",
          children: /*#__PURE__*/_jsx("img", {
            src: chatperson
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "cta-info-right",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "trial-cta-header",
            children: [/*#__PURE__*/_jsx("div", {
              className: "product-logo",
              children: /*#__PURE__*/_jsx(Logo, {})
            }), /*#__PURE__*/_jsx("div", {
              className: "header",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                className: "header",
                message: "trialCtaPage.header"
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: "paragraph",
            children: [/*#__PURE__*/_jsx(FormattedMessage, {
              message: "trialCtaPage.cmsParagraph"
            }), ";"]
          }), /*#__PURE__*/_jsxs("div", {
            className: "trial-cta-button",
            children: [/*#__PURE__*/_jsx("a", {
              className: "button secondary-ghost",
              onClick: onShowVideoModal,
              target: "_blank",
              rel: "noopener noreferrer",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "trialBanner.ctaButtonWatchVideo"
              })
            }), /*#__PURE__*/_jsx("a", {
              className: "button white",
              onClick: handleCtaClick,
              href: `${CTA_BOTTOM_BANNER_LINK}&${parsedUtmParams}`,
              target: "_blank",
              rel: "noopener noreferrer",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "trialBanner.ctaButtonCourse"
              })
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: "microcopy",
            children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
              message: "trialCtaPage.microcopy"
            })
          })]
        })]
      })]
    })
  });
};

TrialCtaPage.propTypes = {
  websiteUrl: PropTypes.string.isRequired
};
export default TrialCtaPage;